import React, { useState, useContext } from "react";
import { UserContext } from "../context/UserContext"; // Import UserContext
import SignUp from "./SignUp"; // Import SignUp component
import Quiz from "./Quiz"; // Import Quiz component
import { FaTimes, FaEye, FaEyeSlash } from "react-icons/fa"; // Import FaTimes, FaEye, and FaEyeSlash icons


const SignInComponent = ({ onClose, onSignUpClick }) => {
  const { setEmailId, setIsLoggedIn, quizFinished } = useContext(UserContext); // Add quizFinished from context
  const [showSignUp, setShowSignUp] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false); // Add state for Quiz modal
  const [formValues, setFormValues] = useState({
    emailId: "",
    password: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRememberMe = () => {
    setRememberMe(!rememberMe);
  };

  const validateForm = () => {
    const errors = {};
    if (!formValues.emailId) errors.emailId = "Email is required";
    if (!formValues.password) errors.password = "Password is required";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSignInSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const emailId = formValues.emailId.trim();
        const response = await fetch("/api/signin", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            emailId,
            password: formValues.password,
            rememberMe,
          }),
        });

        if (response.ok) {
          const data = await response.json();
          setEmailId(emailId);
          setIsLoggedIn(true);
          if (rememberMe) {
            localStorage.setItem("emailId", emailId);
            localStorage.setItem("token", data.token);
            localStorage.setItem("firstName", data.firstName);
          } else {
            localStorage.removeItem("emailId");
            localStorage.removeItem("token");
            localStorage.removeItem("firstName");
          }
          onClose();
          window.location.href = "/main";
        } else {
          const message = (await response.text()).trim();
          alert(
            message ||
              `Sign-in failed (HTTP ${response.status}). Is the API running on port 5000?`
          );
        }
      } catch (error) {
        console.error("Error:", error);
        alert("An error occurred during sign-in");
      }
    }
  };

  const handleSignUpClick = () => {
    if (onSignUpClick) {
      onSignUpClick();
    }
  };

  return (
    <>
      {showSignUp ? (
        <SignUp onClose={() => setShowSignUp(false)} />
      ) : showQuiz ? (
        <Quiz onClose={() => setShowQuiz(false)} />
      ) : (
        <div
          className="modal"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          {showForgotPasswordModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1001,
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  padding: "30px",
                  borderRadius: "10px",
                  width: "400px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                  position: "relative",
                }}
              >
                <button
                  onClick={() => setShowForgotPasswordModal(false)} // Close modal
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "none",
                    border: "none",
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
                <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
                  Forgot Password
                </h2>
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const email = formValues.emailId;

                    if (!email) {
                      alert("Please enter your email address");
                      return;
                    }

                    try {
                      const response = await fetch(
                        "/api/request-password-reset",
                        {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({ email }),
                        }
                      );

                      if (response.ok) {
                        alert("Password reset email sent. Check your inbox.");
                        setShowForgotPasswordModal(false); // Close modal on success
                      } else {
                        alert(
                          "Failed to send password reset email. Please try again."
                        );
                      }
                    } catch (error) {
                      console.error("Error:", error);
                      alert("An error occurred. Please try again.");
                    }
                  }}
                >
                  <div style={{ marginBottom: "20px" }}>
                    <label
                      style={{
                        fontWeight: "bold",
                        marginBottom: "10px",
                        display: "block",
                      }}
                    >
                      Enter your email:
                    </label>
                    <input
                      type="email"
                      name="emailId"
                      value={formValues.emailId}
                      onChange={handleInputChange}
                      placeholder="Enter your email"
                      required
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        fontSize: "14px",
                      }}
                    />
                  </div>
                  <button
                    type="submit"
                    style={{
                      width: "100%",
                      padding: "10px",
                      backgroundColor: "green",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "1rem",
                    }}
                  >
                    Reset Password
                  </button>
                </form>
              </div>
            </div>
          )}

          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              width: "500px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              position: "relative",
            }}
          >
            <button
              onClick={onClose}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "20px",
                color: "#666",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "5px",
              }}
            >
              <FaTimes />
            </button>
            <h2
              style={{
                textAlign: "center",
                marginBottom: "20px",
                fontSize: "1.8rem",
                color: "#333",
              }}
            >
              SIGN IN
            </h2>
            <form onSubmit={handleSignInSubmit} noValidate>
              <div style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                  }}
                >
                  <label
                    style={{
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      flexBasis: "30%",
                      marginRight: "10px",
                    }}
                  >
                    Email:
                    <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="emailId"
                    value={formValues.emailId}
                    onChange={handleInputChange}
                    placeholder="Email"
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      fontSize: "14px",
                    }}
                  />
                </div>
                {formErrors.emailId && (
                  <small
                    style={{
                      color: "red",
                      marginTop: "5px",
                      display: "block",
                      fontSize: "0.85rem",
                      marginLeft: "30%",
                    }}
                  >
                    {formErrors.emailId}
                  </small>
                )}
              </div>

              <div style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                    position: "relative"
                  }}
                >
                  <label
                    style={{
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      flexBasis: "30%",
                      marginRight: "10px"
                    }}
                  >
                    Password:
                    <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  </label>
                  <div style={{ 
                    flex: 1,
                    position: "relative",
                    display: "flex",
                    alignItems: "center"
                  }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formValues.password}
                      onChange={handleInputChange}
                      placeholder="Password"
                      style={{
                        width: "100%",
                        padding: "10px",
                        paddingRight: "40px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        fontSize: "14px"
                      }}
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      style={{
                        position: "absolute",
                        right: "10px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "5px",
                        display: "flex",
                        alignItems: "center",
                        color: "#666"
                      }}
                    >
                      {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                    </button>
                  </div>
                </div>
                {formErrors.password && (
                  <small
                    style={{
                      color: "red",
                      marginTop: "5px",
                      display: "block",
                      fontSize: "0.85rem",
                      marginLeft: "30%"
                    }}
                  >
                    {formErrors.password}
                  </small>
                )}
              </div>

              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px"
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap"
                }}>
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={toggleRememberMe}
                    style={{ 
                      marginRight: "5px",
                      cursor: "pointer",
                      transform: "scale(1.1)"
                    }}
                  />
                  <label style={{ 
                    cursor: "pointer",
                    fontSize: "1rem"
                  }}>Remember Me</label>
                </div>

                <button
                  onClick={() => setShowForgotPasswordModal(true)}
                  style={{
                    color: "#007bff",
                    background: "none",
                    border: "none",
                    textDecoration: "underline",
                    fontSize: "1rem",
                    cursor: "pointer"
                  }}
                >
                  Forgot Password?
                </button>
              </div>

              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "green",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                Submit
              </button>
            </form>
            <div
              style={{ textAlign: "center", marginTop: "15px", fontSize: "0.9rem" }}
            >
              Don't have an account?{" "}
              <button
                onClick={handleSignUpClick}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  color: "#007bff",
                  textDecoration: "underline",
                  cursor: "pointer",
                  font: "inherit",
                  fontSize: "0.9rem"
                }}
              >
                SIGN UP
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignInComponent;
